<template>
        <div class="grid-pagination d-flex justify-content-between align-items-center mt-5 mb-5" v-if="items > 2">
            <ul class="pagination mb-0">
                <li class="page-item" v-if="page > Math.ceil(max/2)  && Math.ceil(items/limit) > max ">
                    <a class="page-link" href="" @click.prevent="setPage(1)">&laquo;</a>
                </li>
                <li class="page-item">
                    <a href="" class="page-link" v-if="page > 1" @click.prevent="setPage(page-1)">&lsaquo;</a>
                </li>
                <li class="page-item" v-if="page > Math.ceil(max/2)+1  && Math.ceil(items/limit) > max ">
                    <a href="" class="page-link" @click.prevent>&hellip;</a>
                </li>
                <li class="page-item" v-for="n in pager" :class="{ active: page === n }" :key="n">
                    <a class="page-link" href="" @click.prevent="setPage(n)">{{ n }}</a>
                </li>
                <li class="page-item" v-if="page < Math.ceil(items/limit) - Math.ceil(max/2) - 1  && Math.ceil(items/limit) > max">
                    <a href="" class="page-link" @click.prevent>&hellip;</a>
                </li>
                <li class="page-item">
                    <a href="" class="page-link" v-if="page < Math.ceil(items/limit)" @click.prevent="setPage(page+1)">&rsaquo;</a>
                </li>
                <li class="page-item" v-if="page <= Math.ceil(items/limit) - Math.ceil(max/2) && Math.ceil(items/limit) > max">
                    <a class="page-link" href="" @click.prevent="setPage(Math.ceil(items/limit))">&raquo;</a>
                </li>
            </ul>
            <div class="pagination-summary text-white">
                {{ (page-1) * limit + 1}} — {{ page * limit }} из {{ items }}
            </div>
            <ul class="pagination mb-0">
                <li :class="{ 'active' : limit === 10, 'page-item' : true }"><a href="" class="page-link" @click.prevent="setPerPage(10)">10</a></li>
                <li :class="{ 'active': limit === 20, 'page-item' : true }"><a class="page-link" href="" @click.prevent="setPerPage(20)">20</a></li>
                <li :class="{ 'active': limit === 50, 'page-item' : true }"><a class="page-link" href=""  @click.prevent="setPerPage(50)">50</a></li>
                <li :class="{ 'active': limit === 100, 'page-item' : true }"><a class="page-link" href="" @click.prevent="setPerPage(100)">100</a></li>
            </ul>

        </div>
</template>

<script>
export default {
  name: 'Pager',
  props: {
    items: Number,
    page: {
      type: [String, Number],
      default: 1
    },
    max: {
      type: Number,
      default: 10
    },
    limit: {
      type: Number,
      default: 100
    }
  },
  computed: {
    pager () {
      let middle = Math.ceil(this.max / 2)
      let current = this.page
      let first = current - middle + 1
      let last = current + this.max - middle
      let max = Math.ceil(this.items / this.limit)

      let i = first

      if (last > max) {
        i = i + (max - last)
        last = max
      }

      if (i <= 0) {
        last = last + (1 - i)
        i = 1
        if (last > max) { last = max }
      }
      let items = []
      while (i <= last) {
        items.push(i)
        i++
      }
      return items
    }
  },
  methods: {
    setPerPage (v) {
      this.$emit('setPerPage', v)
    },
    setPage (v) {
      this.$emit('setPage', v)
    }
  }
}
</script>
